import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const AdminGrantModal = props => {
  const { show, setShow, onYes } = props;

  const [modal, setModal] = useState(false);

  useEffect(() => {
    setModal(show);
  }, [show]);

  const handleCancel = () => {
    setShow(false);
  };

  const handleOk = () => {
    onYes("admin");
    setShow(false);
  };

  return (
    <div>
      <Modal isOpen={modal} backdrop={true} keyboard={false}>
        <ModalHeader>Administrators must be vetted</ModalHeader>
        <ModalBody>
          Are you sure you want to grant administrator privileges to this user?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleOk}>
            Yes, I'm sure.
          </Button>{" "}
          <Button color="secondary" onClick={handleCancel}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AdminGrantModal;
